import { render } from "./SingleTtrImportComponent.vue?vue&type=template&id=93691d56&scoped=true"
import script from "./SingleTtrImportComponent.vue?vue&type=script&lang=js"
export * from "./SingleTtrImportComponent.vue?vue&type=script&lang=js"

import "./SingleTtrImportComponent.vue?vue&type=style&index=0&id=93691d56&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93691d56"]])

export default __exports__